module.exports = __webpack_public_path__ + "static/media/best.ee3d34f6.png";